<template>
  <el-dialog
    :lock-scroll="true"
    width="90%"
    top="0"
    :model-value="_isShow"
    :close-on-click-modal="false"
    :show-close="false"
    @closed="_isShow = false"
    :title="$t('scan_method_selection.title')"
  >
    <template #footer>
      <span class="dialog-footer">
        <div>
          <el-button type="primary" class="full-w-button scan-method-button" @click="selectCamera">
            <div class="action-button">
              <IconScanQR class="scan-icon" />
              <span>{{ $t('scan_method_selection.scan_with_camera') }}</span>
            </div>
          </el-button>
        </div>
        <div>
          <el-button type="primary" class="full-w-button scan-method-button" @click="selectRfid">
            <div class="action-button">
              <IconRfid class="scan-icon" />
              <span>{{ $t('scan_method_selection.scan_with_rfid') }}</span>
            </div>
          </el-button>
        </div>
        <div>
          <el-button @click="_isShow = false" class="full-w-button">
            {{ $t('cancel') }}
          </el-button>
        </div>
      </span>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { PropSync, Prop } from 'vue-property-decorator'
import IconScanQR from '@/components/svg/IconScanQR.vue'
import IconRfid from '@/components/svg/IconRfid.vue'

@Options({
  components: {
    IconScanQR,
    IconRfid,
  },
  name: 'ScanMethodSelectionDialog',
})
export default class ScanMethodSelectionDialog extends Vue {
  @PropSync('isShow', { type: Boolean }) _isShow!: boolean
  @Prop({ type: String, required: true }) readonly actionType!: string
  @Prop({ type: String }) readonly barcodeId?: string

  get projectParam() {
    return this.$store.getters.projectParam
  }

  selectCamera() {
    this._isShow = false
    this.$router.push({
      name: this.getCameraRouteName(),
      params: {
        project: this.projectParam,
        barcodeId: this.barcodeId || this.$store.state.barcode.barcode?.id,
      },
    })
  }

  selectRfid() {
    this._isShow = false
    this.$router.push({
      name: this.getRfidRouteName(),
      params: {
        project: this.projectParam,
        barcodeId: this.barcodeId || this.$store.state.barcode.barcode?.id,
      },
    })
  }

  getCameraRouteName(): string {
    return this.actionType
  }

  getRfidRouteName(): string {
    // Map camera route names to RFID route names
    const routeMap: Record<string, string> = {
      pair: 'pair-rfid',
      'barcode-unpair-scan': 'barcode-unpair-scan-rfid',
      'bulk-recycle': 'bulk-recycle-rfid',
      'link_to-scan': 'link_to-scan-rfid',
      'be_linked-scan': 'be_linked-scan-rfid',
    }
    return routeMap[this.actionType] || `${this.actionType}-rfid`
  }
}
</script>

<style lang="scss" scoped>
.scan-method-button {
  .action-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;

    .scan-icon {
      width: 24px;
      height: 24px;
      flex-shrink: 0;
    }

    span {
      flex: 1;
    }
  }
}
</style>
